import React, { useEffect, useState } from 'react'
import { Toolbar } from '@antv/x6-react-components'
import FlowGraph from '../../Graph'
import { DataUri } from '@antv/x6'
import {
  ClearOutlined,
  SaveOutlined,
  PrinterOutlined,
  DeleteOutlined,
  UndoOutlined,
  RedoOutlined,
  CopyOutlined,
  ScissorOutlined,
  SnippetsOutlined,
  QuestionCircleOutlined,
  BorderOuterOutlined,
  // FullscreenOutlined,
} from '@ant-design/icons'
import '@antv/x6-react-components/es/toolbar/style/index.css'
import 'antd/dist/antd.css';  

import { Tooltip, Popover } from 'antd'
import { Graph, ToolsView, EdgeView } from '@antv/x6'
import ReactDom from 'react-dom'

const Item = Toolbar.Item
const Group = Toolbar.Group

const content = (
  <div>
    <p style={{fontWeight: 'bold'}}>画布：</p> 
    <p>按住Shift键同时鼠标点击画布，可拖拽平移画布</p> 
    <p>按住Ctrl/Command键同时滚动鼠标滚轮，可缩放画布</p> 
    <p style={{fontWeight: 'bold'}}>节点：</p> 
    <p>右击节点，可选择删除节点</p>
    <p style={{fontWeight: 'bold'}}>连接线：</p> 
    <p>右击连接线，可选择删除节点</p>
  </div>
);

class TooltipTool extends ToolsView.ToolItem<EdgeView, TooltipToolOptions> {
  private delay = 100
  private timer!: number
  private knob!: HTMLDivElement 
  private tooltipVisible: boolean | undefined

  render() {
    super.render()
    this.knob = ToolsView.createElement('div', false) as HTMLDivElement
    this.knob.style.position = 'absolute'
    this.container.appendChild(this.knob)
    this.updatePosition()
    document.addEventListener('mousemove', this.onMouseMove)

    return this
  }

  private toggleTooltip(visible: boolean) {
    ReactDom.unmountComponentAtNode(this.knob)

    if (visible) {
      ReactDom.render(
        <Tooltip title={this.options.tooltip} visible={true}>
          <div />
        </Tooltip>,
        this.knob,
      )
    }
    this.tooltipVisible = visible
  }

  private updatePosition(e?: MouseEvent) {
    const style = this.knob.style
    if (e) {
      const p = this.graph.clientToGraph(e.clientX, e.clientY)
      style.display = 'block'
      style.left = `${p.x}px`
      style.top = `${p.y}px`
    } else {
      style.display = 'none'
      style.left = '-1000px'
      style.top = '-1000px'
    }
  }

  private onMouseLeave() {
    this.updatePosition()
    window.clearTimeout(this.timer)
    window.setTimeout(() => this.toggleTooltip(false), this.delay)
    document.removeEventListener('mousemove', this.onMouseMove)
  }

  private onMouseMove = (e: MouseEvent) => {
    window.clearTimeout(this.timer)
    this.updatePosition(e)
    this.timer = window.setTimeout(() => {
      if (this.tooltipVisible) {
        this.toggleTooltip(false)
      }
      this.toggleTooltip(true)
    }, this.delay)
  }

  delegateEvents() {
    this.cellView.on('cell:mouseleave', this.onMouseLeave, this)
    return super.delegateEvents()
  }

  protected onRemove() {
    this.cellView.off('cell:mouseleave', this.onMouseLeave, this)
  }
}

TooltipTool.config({
  tagName: 'div',
  isSVGElement: false,
})

export interface TooltipToolOptions extends ToolsView.ToolItem.Options {
  tooltip?: string
}

Graph.registerNodeTool('tooltip', TooltipTool, true)
Graph.registerEdgeTool('tooltip', TooltipTool, true)

export default function (props: any) {
  const [canUndo, setCanUndo] = useState(false)
  const [canRedo, setCanRedo] = useState(false)

  const copy = () => {
    const { graph } = FlowGraph
    const cells = graph.getSelectedCells()
    if (cells.length) {
      graph.copy(cells)
    }
    return false
  }

  const cut = () => {
    const { graph } = FlowGraph
    const cells = graph.getSelectedCells()
    if (cells.length) {
      graph.cut(cells)
    }
    return false
  }

  const paste = () => {
    const { graph } = FlowGraph
    if (!graph.isClipboardEmpty()) {
      const cells = graph.paste({ offset: 32 })
      graph.cleanSelection()
      graph.select(cells)
    }
    return false
  }

  const del = () => {
    const { graph } = FlowGraph
    const cells = graph.getSelectedCells()
    if (!cells.length) {
      return
    }
    const edges = graph.getConnectedEdges(cells as any)
    const targets = [...cells, ...edges]
    if (targets.length) {
      graph.removeCells(targets)
    }
  }

  useEffect(() => {
    const { graph } = FlowGraph
    const { history } = graph
    setCanUndo(history.canUndo())
    setCanRedo(history.canRedo())
    history.on('change', () => {
      setCanUndo(history.canUndo())
      setCanRedo(history.canRedo())
    })

    graph.bindKey('meta+z', () => {
      if (history.canUndo()) {
        history.undo()
      }
      return false
    })
    graph.bindKey('meta+shift+z', () => {
      if (history.canRedo()) {
        history.redo()
      }
      return false
    })
    graph.bindKey('meta+d', () => {
      graph.clearCells()
      return false
    })
    graph.bindKey('meta+s', () => {
      graph.toPNG((datauri: string) => {
        DataUri.downloadDataUri(datauri, 'chart.png')
      })
      return false
    })
    graph.bindKey('meta+p', () => {
      graph.printPreview()
      return false
    })
    graph.bindKey('meta+c', copy)
    graph.bindKey('meta+v', paste)
    graph.bindKey('meta+x', cut)

    //  graph.bindKey('del', () => {
    //   const cells = graph.getSelectedCells()
    //   if (cells.length) {
    //     graph.removeCells(cells)
    //   }
    // })
  }, [])

  const handleClick = (name: string) => {
    const { graph } = FlowGraph
    switch (name) {
      case 'undo':
        graph.history.undo()
        break
      case 'redo':
        graph.history.redo()
        break
      case 'clear':
        graph.clearCells()
        break
      case 'delete':
        del()
        break
      case 'save':
        graph.toPNG((datauri: string) => {
          DataUri.downloadDataUri(datauri, 'chart.png')
        })
        break
      case 'print':
        graph.printPreview()
        break
      case 'copy':
        copy()
        break
      case 'cut':
        cut()
        break
      case 'paste':
        paste()
        break
      // 重置画布视图
      case 'resetGraphView':
        // 恢复到中心位置
        graph.centerContent();

        // 恢复到原始大小
        graph.zoomTo(1);
        break;
      default:
        break
    }
  }

  return (
    <div className="x6-graph-wrap">
      <Toolbar hoverEffect={true} size="small" onClick={handleClick}>    
        <Group>
          <div style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                color: '#595959',
              }}>
          <Item
            name="clear"
            icon={<ClearOutlined />}
            tooltip="清除 (Cmd/Ctrl + D)"
          /></div>
          <div style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                color: '#595959',
              }}>
          <Item 
            name="delete" 
            icon={<DeleteOutlined />} 
            tooltip="删除 (Delete)" 
          /></div>
        </Group>
        <Group>
          <div style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                color: '#595959',
              }}>
          <Item
            name="undo"
            tooltip="撤销 (Cmd/Ctrl + Z)"
            icon={<UndoOutlined />}
            disabled={!canUndo}
          /></div>
          <div style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                color: '#595959',
              }}>
          <Item
            name="redo"
            tooltip="重做 (Cmd/Ctrl + Shift + Z)"
            icon={<RedoOutlined />}
            disabled={!canRedo}
          /></div>
        </Group>
        <Group>
          <div style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                color: '#595959',
              }}>
            <Item name="copy" icon={<CopyOutlined />} tooltip="复制 (Cmd/Ctrl + C)" /></div>
          <div style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                color: '#595959',
              }}>
            <Item name="cut" icon={<ScissorOutlined />} tooltip="剪切 (Cmd/Ctrl + X)" /></div>
          <div  
          style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                color: '#595959',
              }}>
          <Item
            name="paste"
            tooltip="粘贴 (Cmd/Ctrl + V)"
            icon={<SnippetsOutlined />}
          />
          </div>
        </Group>
        <Group>
          <div  style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                color: '#595959',
              }}>
          <Item name="save" icon={<SaveOutlined />} tooltip="保存 (Cmd/Ctrl + S)"/></div>
          <div style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                color: '#595959',
              }}>
          <Item
            name="print"
            icon={<PrinterOutlined />}
            tooltip="打印 (Cmd/Ctrl + P)"
          />
          </div>
        </Group>
        <Group>
          <Item
            name="resetGraphView"
            icon={<BorderOuterOutlined />}
            tooltip="重置画布视图"
          />
        </Group>
        <Group>
          <Popover content={content} title="操作指南">
            <span 
              style={{    
                display: 'inline-block',
                fontSize: '12px',
                marginTop: '4px',
                marginLeft: '4px',
                paddingTop: '2px',
                color: '#595959',
              }}
              ><QuestionCircleOutlined/></span>
          </Popover>
        </Group>  
      </Toolbar>

    </div>
  )
}
